<template>
  <header class="ba-absolute md:ba-static ba-top-0 ba-inset-x-0">
    <div
      class="ba-flex ba-justify-center ba-items-center ba-h-26 md:ba-hidden"
      :class="login ? 'ba-bg-white' : 'ba-bg-primary-strong'"
    >
      <a :href="$options.PORTAL_URL">
<!--        <s-logo-->
<!--          class="ba-h-11"-->
<!--          :color="!login ? 'ba-text-white' : ''"-->
<!--        />-->
        <s-logo-gray v-if="!login" class="ba-h-11"/>
        <s-logo-blue v-else class="ba-h-11"/>
      </a>
    </div>

    <div class="ba-hidden md:ba-block">
      <div class="s-login-layout__wave"></div>

      <div class="ba-relative ba-transition-colors ba-duration-100">
        <a :href="$options.PORTAL_URL">
          <s-logo-gray v-if="!login" class="s-login-layout__logo ba-w-full"/>
          <s-logo-blue v-else class="s-login-layout__logo ba-w-full"/>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import SLogoBlue from "./s-logo-blue";
import SLogoGray from "./s-logo-gray";

export default {
  components: { SLogoBlue, SLogoGray },
  props: {
    login: {
      type: Boolean,
      default: false
    }
  },
  PORTAL_URL: "#!"
};
</script>
